import script from "./CampaignPCs.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignPCs.vue?vue&type=script&setup=true&lang=ts"

import "./CampaignPCs.vue?vue&type=style&index=0&id=3c289bbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c289bbb"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSelect,QChip,QField});
